export default __webpack_public_path__ + "static/media/buddy7.b816888c.jpeg";